// "2025-08-14T04:35:45Z" -> "14 Aug 2025". Empty text if the value is not a date.
const formatDate = (value) => {
	const date = new Date(value);
	if (isNaN(date.getTime())) return "";
	return date.toLocaleDateString("en-GB", {
		day: "numeric",
		month: "short",
		year: "numeric",
	});
};

export default formatDate;
